(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6002],{

/***/ 3066:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _from = _interopRequireDefault(__webpack_require__(7187));

var _assign = _interopRequireDefault(__webpack_require__(53570));

var _react = __webpack_require__(34885);

var defaultOptions = {
  current: 1,
  splitter: [1, 1, 1],
  onChange: function onChange() {},
  label: function label(page) {
    return page;
  }
};

function usePagination(options) {
  var _Object$assign = (0, _assign["default"])({}, defaultOptions, options),
      current = _Object$assign.current,
      splitter = _Object$assign.splitter,
      onChange = _Object$assign.onChange,
      count = _Object$assign.count,
      href = _Object$assign.href,
      label = _Object$assign.label;

  var nextPage = Math.min(current + 1, count);
  var prevPage = Math.max(current - 1, 1);

  var goToNext = function goToNext() {
    onChange(nextPage);
  };

  var goToPrev = function goToPrev() {
    onChange(prevPage);
  };

  var goTo = function goTo(index) {
    if (index < 1 || index > count) {
      throw new Error("[usePagination] wrong attribute for goTo, must be between 1 to ".concat(count, " (was ").concat(index, ")"));
    }

    onChange(index);
  };

  var pageArray = (0, _from["default"])(Array(count).keys()).map(function (x) {
    return x + 1;
  }); // button groups

  var pageButtonGroups = [];
  var parts = [];

  if (count <= splitter[0] + splitter[1] * 2 + 1 + splitter[2]) {
    pageButtonGroups.push(pageArray);
  } else {
    if (current <= splitter[0] + splitter[1] + 1) {
      pageButtonGroups.push(pageArray.slice(0, current + splitter[1]));
      pageButtonGroups.push(pageArray.slice(-splitter[2]));
    } else if (current >= count - (splitter[2] + splitter[1])) {
      pageButtonGroups.push(pageArray.slice(0, splitter[0]));
      pageButtonGroups.push(pageArray.slice(current - 1 - splitter[1], count));
    } else {
      pageButtonGroups.push(pageArray.slice(0, splitter[0]));
      pageButtonGroups.push(pageArray.slice(current - 1 - splitter[1], current - 1 + splitter[1] + 1));
      pageButtonGroups.push(pageArray.slice(-splitter[2]));
    }
  }

  pageButtonGroups.forEach(function (group, index) {
    if (index > 0) {
      parts.push({
        type: "separator"
      });
    }

    parts.push({
      type: "buttons",
      buttons: group.map(function (page) {
        return {
          page: page,
          props: {
            onClick: function onClick() {
              return goTo(page);
            },
            href: href ? href(page) : undefined
          }
        };
      })
    });
  });
  var selectOptions = pageArray.map(function (page) {
    return {
      value: page.toString(),
      label: label(page),
      page: page
    };
  });
  var vals = {
    current: current,
    count: count,
    prevButtonActive: current > 1,
    nextButtonActive: current < count,
    nextButtonProps: {
      onClick: goToNext,
      href: href ? href(nextPage) : undefined
    },
    prevButtonProps: {
      onClick: goToPrev,
      href: href ? href(prevPage) : undefined
    },
    goToNext: goToNext,
    goToPrevious: goToPrev,
    goTo: goTo,
    selectProps: {
      options: selectOptions,
      value: selectOptions[current - 1],
      onChange: function onChange(val) {
        goTo(val.page);
      }
    },
    parts: parts
  };
  return vals;
}

var _default = usePagination;
exports["default"] = _default;

/***/ }),

/***/ 73650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useAccordion = useAccordion;
exports.Accordion = Accordion;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(3498));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

function useAccordion() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sections = props.sections,
      _props$oneAtATime = props.oneAtATime,
      oneAtATime = _props$oneAtATime === void 0 ? false : _props$oneAtATime; // Hook uncontrolled right now

  var _useState = (0, _react.useState)(sections.map(function (s) {
    return s.isOpenAtInit || false;
  })),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var newSections = sections.map(function (section, index) {
    var open = function open() {
      var newIsOpen = (0, _toConsumableArray2["default"])(isOpen); //
      // if (oneAtATime) {
      //     newIsOpen = new Array(sections.length).fill(false);
      // }

      newIsOpen[index] = true;
      setOpen(newIsOpen);
    };

    var close = function close() {
      var newIsOpen = (0, _toConsumableArray2["default"])(isOpen);
      newIsOpen[index] = false;
      setOpen(newIsOpen);
    };

    var toggle = function toggle() {
      if (isOpen[index]) {
        close();
      } else {
        open();
      }
    };

    return {
      open: open,
      close: close,
      toggle: toggle,
      buttonProps: {
        onClick: function (_onClick) {
          function onClick() {
            return _onClick.apply(this, arguments);
          }

          onClick.toString = function () {
            return _onClick.toString();
          };

          return onClick;
        }(function () {
          toggle();

          if (sections.onClick) {
            onClick.apply(void 0, arguments);
          }
        }),
        selected: isOpen[index]
      },
      showHideProps: {
        isOpen: isOpen[index]
      }
    };
  });
  return {
    sections: newSections
  };
}

function AccordionSection(props) {}

function Accordion(props) {
  var children = props.children,
      controller = props.controller,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["children", "controller"]);
  children = _react["default"].Children.toArray(children);
  var sections = [];
  children.forEach(function (child, index) {
    if (child.type === AccordionSection) {
      var grandChildren = _react["default"].Children.toArray(child.props.children);

      var _child$props = child.props,
          isOpenAtInit = _child$props.isOpenAtInit,
          _restProps = (0, _objectWithoutProperties2["default"])(_child$props, ["isOpenAtInit"]);

      sections.push({
        button: grandChildren[0],
        showHide: grandChildren[1],
        headerAs: child.props.headerAs || "h6",
        isOpenAtInit: isOpenAtInit,
        props: _restProps
      });
    }
  });

  if (!controller) {
    controller = useAccordion((0, _objectSpread2["default"])({
      sections: sections.map(function (section) {
        return {
          isOpenAtInit: section.isOpenAtInit
        };
      })
    }, props));
  }

  var i = 0;
  return __jsx(_Box["default"], restProps, children.map(function (child, index) {
    if (child.type === AccordionSection) {
      var section = sections[i];
      var sectionController = controller.sections[i];
      i++;
      return __jsx(_Box["default"], (0, _extends2["default"])({}, section.props, {
        key: child.key || index
      }), __jsx(_Box["default"], {
        as: section.headerAs
      }, _react["default"].cloneElement(section.button, sectionController.buttonProps)), _react["default"].cloneElement(section.showHide, sectionController.showHideProps));
    }

    return child;
  }));
}

Accordion.Section = AccordionSection;
var _default = Accordion;
exports["default"] = _default;

/***/ }),

/***/ 35139:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useMultiSelectInline = useMultiSelectInline;
exports.MultiSelectInline = MultiSelectInline;
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _SelectInline = __webpack_require__(71070);

var _useMultiSelectState = _interopRequireDefault(__webpack_require__(23851));

function useMultiSelectInline(props) {
  var controller = (0, _useMultiSelectState["default"])(props);
  return (0, _objectSpread2["default"])({}, controller, {
    selectableProps: (0, _SelectInline.getSelectableProps)(controller, props)
  });
}

function MultiSelectInline(_ref) {
  var controller = _ref.controller,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["controller"]);

  if (!controller) {
    controller = useMultiSelectInline(props);
  }

  return (0, _SelectInline.getChildren)(controller, props);
}

var _default = MultiSelectInline;
exports["default"] = _default;

/***/ }),

/***/ 84633:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.normalizeRangePickerValue = normalizeRangePickerValue;
exports.useRangePicker = useRangePicker;
exports.useRangePicker_controlled = useRangePicker_controlled;
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _parseFloat2 = _interopRequireDefault(__webpack_require__(95946));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

/**
 * Behaviour:
 * - RangePicker is a control, has value and onChange
 * - value is object in a form { from: [number], to: [number] }. from and to can be null if allowEmpty is true.
 * - min, max, allowEmpty - these are available behaviour flags
 * - if allowEmpty=true, then value from / to might be null.
 * - min and max are obvious, they set boundaries for range
 *
 * Incorrect values:
 * - if entire object is incorrect it's either {} or {from: [min], to:[max]} when allowEmpty is true or false respectively
 * - for "from" and "to" there are 2 types of incorrectness
 * - a) value not a number. This should be forbidden by input type=number but still. If allowEmpty=true => null, otherwise min/max
 * - b) value is a number but not in range <min;max>. Falls back always to min/max (no matter if allowEmpty=true/false).
 *
 */
function snapToMinMax(props, value) {
  var min = props.min,
      max = props.max;

  if (typeof min === "number") {
    value = Math.max(min, value);
  }

  if (typeof max === "number") {
    value = Math.min(max, value);
  }

  return value;
}

function normalizeRangePickerValue(props) {
  var keepMin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var value = props.value,
      min = props.min,
      max = props.max,
      _props$allowEmpty = props.allowEmpty,
      allowEmpty = _props$allowEmpty === void 0 ? false : _props$allowEmpty,
      _props$fractionDigits = props.fractionDigits,
      fractionDigits = _props$fractionDigits === void 0 ? 0 : _props$fractionDigits;

  if (!allowEmpty && (typeof min !== "number" || typeof max !== "number")) {
    throw new Error("[RangePicker] If allowEmpty=false, you must set min and max props");
  }

  if (value === undefined || value === null) {
    return allowEmpty ? {
      from: null,
      to: null
    } : {
      from: min,
      to: max
    };
  }

  if (typeof value !== "object") {
    return allowEmpty ? {
      from: null,
      to: null
    } : {
      from: min,
      to: max
    };
  }

  var ret = {
    from: null,
    to: null
  };

  if (typeof value.from === "number" && !isNaN(value.from)) {
    ret.from = snapToMinMax(props, value.from);
  } else {
    if (!allowEmpty) {
      ret.from = min;
    }
  }

  if (typeof value.to === "number" && !isNaN(value.to)) {
    ret.to = snapToMinMax(props, value.to);
  } else {
    if (!allowEmpty) {
      ret.to = max;
    }
  }

  if (typeof ret.from === "number" && typeof ret.to === "number" && ret.from > ret.to) {
    if (keepMin) {
      if (allowEmpty) {
        ret.to = null;
      } else {
        ret.to = max;
      }
    } else {
      if (allowEmpty) {
        ret.from = null;
      } else {
        ret.from = min;
      }
    }
  }

  if (typeof ret.from === "number") {
    ret.from = (0, _parseFloat2["default"])(ret.from.toFixed(fractionDigits));
  }

  if (typeof ret.to === "number") {
    ret.to = (0, _parseFloat2["default"])(ret.to.toFixed(fractionDigits));
  }

  return ret;
}

function useRangePicker(props) {
  var isControlled = typeof props.value !== "undefined";

  var _useState = (0, _react.useState)(props.defaultValue),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var controller = useRangePicker_controlled(isControlled ? props : (0, _objectSpread2["default"])({}, props, {
    value: internalValue,
    onChange: function onChange(newVal) {
      setInternalValue(newVal);

      if (props.onChange) {
        props.onChange(newVal);
      }
    }
  }));
  return (0, _objectSpread2["default"])({}, controller, {
    setValue: function setValue(newVal) {
      if (!isControlled) {
        setInternalValue(newVal);
      }
    }
  });
}

function parseValue(val) {
  if (typeof val === "string") {
    val = val.replace(/ /g, ""); // remove whitespace

    val = val.replace(/\,/g, "."); // change comma to
  }

  return (0, _parseFloat2["default"])(val);
}

function useRangePicker_controlled(props) {
  var value = props.value,
      onChange = props.onChange,
      _props$onChangeTimeou = props.onChangeTimeout,
      onChangeTimeout = _props$onChangeTimeou === void 0 ? null : _props$onChangeTimeou;
  value = normalizeRangePickerValue(props, value);

  var _useState2 = (0, _react.useState)((0, _objectSpread2["default"])({}, value, {
    lastEdited: "from"
  })),
      inputValue = _useState2[0],
      setInputValue = _useState2[1]; // raw input data


  var timeout = (0, _react.useRef)(null); // internal value is normalized value based on current inputValue (doesn't have to be commited value!)

  var internalValue = normalizeRangePickerValue((0, _objectSpread2["default"])({}, props, {
    value: {
      from: parseValue(inputValue.from),
      to: parseValue(inputValue.to)
    }
  }), inputValue.lastEdited === "from");
  /**
   * If value changes in props, we should update inputs. BUT, only if value REALLY changes, which means when normalized value changed compared to local state.
   */

  (0, _react.useEffect)(function () {
    var newValueFromProps = normalizeRangePickerValue(props, inputValue.lastEdited); // This condition is very important. If value from props changes but after normalization it's same as current input values, we keep input values. Otherwise it would disrupt inputting UX.

    if (newValueFromProps.from === internalValue.from && newValueFromProps.to === internalValue.to) {
      return;
    }

    setInputValue((0, _objectSpread2["default"])({}, value, {
      lastEdited: inputValue.lastEdited
    }));
  }, [value.from, value.to]);

  var onBlur = function onBlur() {
    setInputValue(internalValue);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(function () {
      // if (value.from === internalValue.from && value.to === internalValue.to) {
      //   return;
      // }
      if (onChange) {
        onChange(internalValue, true);
      }
    }, 0);
  };

  var onFocus = function onFocus() {
    clearTimeout(timeout.current);
  };

  var change = function change(newVal, lastEdited) {
    newVal = (0, _objectSpread2["default"])({}, inputValue, newVal, {
      lastEdited: lastEdited
    });
    setInputValue(newVal);

    if (onChange) {
      onChange(normalizeRangePickerValue((0, _objectSpread2["default"])({}, props, {
        value: {
          from: parseValue(newVal.from),
          to: parseValue(newVal.to)
        }
      }), lastEdited), false);
    }
  };

  var inputFromProps = {
    value: inputValue.from === null || inputValue.from === undefined ? "" : inputValue.from.toString(),
    onChange: function onChange(newVal) {
      change({
        from: newVal
      }, "from");
    },
    onBlur: onBlur,
    onFocus: onFocus,
    label: "From",
    type: "text",
    inputmode: "numeric"
  };
  var inputToProps = {
    value: inputValue.to === null || inputValue.to === undefined ? "" : inputValue.to.toString(),
    onChange: function onChange(newVal) {
      change({
        to: newVal
      }, "to");
    },
    onBlur: onBlur,
    onFocus: onFocus,
    label: "To",
    type: "text",
    inputmode: "numeric"
  };
  return {
    inputFromProps: inputFromProps,
    inputToProps: inputToProps,
    value: internalValue,
    commit: onBlur
  };
}
/**
 * NOTES:
 *
 * 1. We should work on accessibility, labels, fieldset, etc. We should think if there shouldn't be form.
 * 2. We should add clear button.
 * 3. Basic layout (input, separator, input, potentially clear button on the left / right handside) is just basic. We should allow for render props to do ANY layout out of those elements.
 * 4. Timeout / ENTER on submit.
 * 5. Think of mobile users. What happens when someone wants to hide the keyboard, or submits. Keyboard should hide and calculations should take place!
 * 6. We should have onChange and onCommit events. onCommit doesn't run when someone is editing the price (to prevent unnecessary reloads etc). onCommit can run after timeout of user being idle. OR on ENTER. OR on keyboard submit on mobile.
 */


function RangePicker(_ref) {
  var controller = _ref.controller,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["controller"]);

  if (!controller) {
    controller = useRangePicker(props);
  }

  var inputFrom = props.inputFrom,
      inputTo = props.inputTo,
      separator = props.separator;

  if (_react["default"].isValidElement(separator)) {} else if (typeof separator === "object") {
    separator = __jsx(_Box["default"], {
      sx: (0, _objectSpread2["default"])({}, separator)
    });
  }

  inputFrom = _react["default"].cloneElement(inputFrom, (0, _objectSpread2["default"])({}, controller.inputFromProps, {
    label: inputFrom.props && inputFrom.props.label
  }));
  inputTo = _react["default"].cloneElement(inputTo, (0, _objectSpread2["default"])({}, controller.inputToProps, {
    label: inputTo.props && inputTo.props.label
  }));
  return __jsx(_Box["default"], {
    as: "form",
    sx: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      controller.commit();
    }
  }, __jsx(_Box["default"], {
    sx: {
      flex: "1 1 auto"
    }
  }, inputFrom), separator && __jsx(_Box["default"], {
    sx: {
      flex: "0 0 auto"
    }
  }, separator), __jsx(_Box["default"], {
    sx: {
      flex: "1 1 auto"
    }
  }, inputTo), __jsx("button", {
    type: "submit",
    hidden: true
  }));
}

var _default = RangePicker;
exports["default"] = _default;

/***/ }),

/***/ 7222:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useSelect = useSelect;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _ButtonRaw = _interopRequireDefault(__webpack_require__(30650));

var _downshift = __webpack_require__(64467);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _Layer = _interopRequireDefault(__webpack_require__(24946));

var _SelectInline = __webpack_require__(71070);

var _useSelectState = _interopRequireDefault(__webpack_require__(88829));

var __jsx = _react["default"].createElement;

function useSelect(props) {
  /**
   * we keep a bit different naming:
   * - options
   * - value
   * - onChange
   */
  var selectState = (0, _useSelectState["default"])(props);
  var options = selectState.options,
      value = selectState.value,
      setValue = selectState.setValue; // Stateful / Stateless

  var downshiftOptions = {
    items: options,
    selectedItem: value,
    onSelectedItemChange: function onSelectedItemChange(item) {
      setValue(item.selectedItem);
    }
  };
  var downshiftSelect = (0, _downshift.useSelect)(downshiftOptions);
  var buttonPropsDownshift = downshiftSelect.getToggleButtonProps();
  var anchorRef = (0, _react.useRef)(null);

  var buttonRef = function buttonRef(element) {
    buttonPropsDownshift.ref(element);
    anchorRef.current = element;
  };

  var buttonProps = (0, _objectSpread2["default"])({}, buttonPropsDownshift, {
    buttonRef: buttonRef
  });
  delete buttonProps.ref;
  var newOptions = options.map(function (option, index) {
    var itemDownshiftProps = downshiftSelect.getItemProps({
      index: index,
      item: option
    });
    itemDownshiftProps._ref = itemDownshiftProps.ref;
    delete itemDownshiftProps.ref;
    return (0, _objectSpread2["default"])({}, option, {
      selectableProps: (0, _objectSpread2["default"])({
        selected: value && option.id === value.id,
        highlighted: downshiftSelect.highlightedIndex === index,
        disabled: !!option.disabled,
        option: option,
        value: option.id,
        key: option.id,
        label: option.label
      }, itemDownshiftProps)
    });
  });
  var layerProps = {
    isOpen: downshiftSelect.isOpen
  };
  return (0, _objectSpread2["default"])({}, downshiftSelect, selectState, {
    // TODO: open, close functions
    options: newOptions,
    menuProps: downshiftSelect.getMenuProps(),
    layerProps: layerProps,
    anchorRef: anchorRef,
    buttonProps: buttonProps
  });
}
/**
 * Select can be styled as 'InputContainer' and also as with a separate custom button.
 * We should clean this up and especially clean up InputContainer concept.
 *
 */


function Select2(props) {
  var label = props.label,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? "Select value" : _props$placeholder,
      onClick = props.onClick,
      controller = props.controller,
      button = props.button,
      separator = props.separator,
      selectable = props.selectable,
      width = props.width,
      height = props.height,
      minWidth = props.minWidth,
      minHeight = props.minHeight,
      maxWidth = props.maxWidth,
      maxHeight = props.maxHeight,
      animationTime = props.animationTime,
      animationEase = props.animationEase,
      backgroundColor = props.backgroundColor,
      root = props.root,
      container = props.container,
      placement = props.placement,
      anchoredTo = props.anchoredTo,
      header = props.header,
      footer = props.footer,
      children = props.children;
  var layerProps = {
    width: width,
    height: height,
    minWidth: minWidth,
    minHeight: minHeight,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    animationTime: animationTime,
    animationEase: animationEase,
    backgroundColor: backgroundColor,
    root: root,
    container: container,
    placement: placement,
    anchoredTo: anchoredTo,
    header: header,
    footer: footer
  };

  if (!controller) {
    controller = (0, _useSelectState["default"])(props);
  }

  var _controller = controller,
      buttonProps = _controller.buttonProps,
      menuProps = _controller.menuProps,
      anchorRef = _controller.anchorRef,
      options = _controller.options,
      value = _controller.value,
      isOpen = _controller.isOpen,
      openMenu = _controller.openMenu;
  options = controller.options; // TODO: should be possible to make it a function
  // TODO: pass "selected", "disabled", "error", "placehoder", "selectedOption", "selectedValue"
  // const button = React.cloneElement($button, {
  //   ...buttonProps,
  //   sx: { ...$button.props.sx, ...restSx }
  // });

  button = typeof button === "function" ? button(controller) : button;
  return __jsx(_Layer["default"], (0, _extends2["default"])({}, layerProps, {
    button: _react["default"].cloneElement(button, buttonProps)
  }), function (_ref) {
    var close = _ref.close;
    var items = [];
    var selectableProps = (0, _SelectInline.getSelectableProps)(controller, props, {
      allowUnselect: false
    });
    selectableProps = selectableProps.map(function (props) {
      return (0, _objectSpread2["default"])({}, props, {
        onClick: function onClick() {
          props.onClick.apply(props, arguments);
          close();
        }
      });
    });

    if (typeof children === "function") {
      var optionsArg = options.map(function (option, index) {
        return (0, _objectSpread2["default"])({}, option, {
          selectableProps: selectableProps[index]
        });
      });
      items = children({
        options: optionsArg
      });
    } else {
      options.forEach(function (option, i) {
        var item = typeof selectable === "function" ? selectable({
          option: option
        }) : selectable;
        items.push(_react["default"].cloneElement(item, selectableProps[i])); // TODO: we need more flexibility with item look

        if (separator && i < options.length - 1) {
          items.push(_react["default"].cloneElement(separator, {
            role: "separator",
            key: "separator-" + i
          }));
        }
      });
    }

    return __jsx(_Box["default"], null, items);
  });
}

var _default = Select2;
exports["default"] = _default;

/***/ }),

/***/ 22040:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _Selectable = _interopRequireDefault(__webpack_require__(53910));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _index = __webpack_require__(79329);

var __jsx = _react["default"].createElement;
var defaults = {
  $root: function $root(_ref) {
    var focused = _ref.focused;
    return {
      width: 20,
      height: 20,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };
  }
};

function Checkmark() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return __jsx(_Selectable["default"], props, function (state) {
    var sx = props.sx;

    if (typeof sx === "function") {
      sx = sx(state);
    }

    var _splitSx = (0, _index.splitSx)(sx),
        _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
        css = _splitSx2[0],
        customSx = _splitSx2[1];

    var iconStyles = customSx.$icon || {};

    if (typeof iconStyles === "function") {
      iconStyles = iconStyles(state);
    }

    return __jsx(_Box["default"], {
      sx: [defaults.$root(state), css]
    }, __jsx(_Box["default"], {
      as: "svg",
      viewBox: "0 0 14 14",
      focusable: "false",
      role: "presentation",
      sx: (0, _objectSpread2["default"])({
        display: "block",
        width: 12,
        height: 12
      }, iconStyles)
    }, __jsx("g", {
      fill: "currentColor"
    }, __jsx("polygon", {
      points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
    }))));
  });
}

var _default = Checkmark;
exports["default"] = _default;

/***/ }),

/***/ 23851:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useMultiSelectState_controlled = useMultiSelectState_controlled;
exports["default"] = exports.normalizeMultiSelectValue = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(3498));

var _isArray = _interopRequireDefault(__webpack_require__(99228));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = __webpack_require__(34885);

var _useSelectState = __webpack_require__(88829);

function filterProps(props) {
  var options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      allowEmpty = props.allowEmpty,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["options", "value", "defaultValue", "onChange", "allowEmpty"]);
  return restProps;
}

var originalValueArray = function originalValueArray(arr) {
  return arr.map(_useSelectState.originalValue);
};

var getValIndexArray = function getValIndexArray(options, arr) {
  return arr.map(function (val) {
    return (0, _useSelectState.getValIndex)(options, val);
  });
};

var normalizeMultiSelectValue = function normalizeMultiSelectValue(options, val) {
  options = (0, _useSelectState.normalizeSelectOptions)(options);

  if (val === null || val === undefined) {
    return [];
  }

  if (!(0, _isArray["default"])(val)) {
    return [];
  }

  var newVal = [];

  var _loop = function _loop(i) {
    var v = val[i];

    if (v === null || v === undefined) {
      return "continue";
    }

    var valueObject = v;

    if (typeof v !== "object") {
      // if value is not object, then we treat it as id
      valueObject = options.find(function (o) {
        return o.id === v.toString();
      });
    }

    if (!valueObject || valueObject.id === null || valueObject.id === undefined) {
      return "continue";
    }

    valueObject.id = valueObject.id.toString();
    newVal.push(valueObject);
  };

  for (var i = 0; i < val.length; i++) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  }

  return newVal;
};

exports.normalizeMultiSelectValue = normalizeMultiSelectValue;

function are2ArraysOfValuesEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  var ids = {};
  arr1.forEach(function (val) {
    ids[val.id] = true;
  });

  for (var i = 0; i < arr2.length; i++) {
    var id = arr2[i].id;

    if (ids[id] !== true) {
      return false;
    }
  }

  return true;
}

function useMultiSelectState_controlled(props) {
  var options = props.options,
      value = props.value,
      onChange = props.onChange;
  options = (0, _useSelectState.normalizeSelectOptions)(options);
  var normalizedValue = normalizeMultiSelectValue(options, value);

  var setValue = function setValue(newVal) {
    newVal = normalizeMultiSelectValue(options, newVal);

    if (are2ArraysOfValuesEqual(newVal, normalizedValue)) {
      return;
    }

    if (onChange) {
      onChange(originalValueArray(newVal), getValIndexArray(options, newVal));
    }
  };

  var isSelected = function isSelected(val) {
    if (val === undefined || val === null) {
      return false;
    }

    var id = typeof val === "object" ? val.id : val;

    if (normalizedValue.find(function (x) {
      return x.id === id;
    })) {
      return true;
    }

    return false;
  };

  return {
    value: originalValueArray(normalizedValue),
    valueObject: normalizedValue,
    selectedIndex: getValIndexArray(options, normalizedValue),
    options: options,
    reset: function reset() {
      setValue([]);
    },
    setValue: setValue,
    isSelected: isSelected,
    selectValue: function selectValue(val) {
      if (isSelected(val)) {
        return;
      } else {
        setValue([].concat((0, _toConsumableArray2["default"])(normalizedValue), [val]));
      }
    },
    unselectValue: function unselectValue(val) {
      if (!isSelected(val)) {
        return;
      } else {
        setValue(normalizedValue.filter(function (x) {
          return !(x.id === val.id || x.id === val);
        }));
      }
    }
  };
}

function useMultiSelectState(props) {
  var options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      _onChange = props.onChange; // UNCONTROLLED ONLY IF: value === "undefined"

  var isControlled = typeof value !== "undefined";

  var _useState = (0, _react.useState)(normalizeMultiSelectValue(options, defaultValue)),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var currentValue = isControlled ? value : internalValue;
  return useMultiSelectState_controlled((0, _objectSpread2["default"])({}, props, {
    value: currentValue,
    onChange: function onChange(newVal, index) {
      if (!isControlled) {
        setInternalValue(newVal);
      }

      if (_onChange) {
        _onChange(newVal, index);
      }
    }
  }));
}

var _default = useMultiSelectState;
exports["default"] = _default;

/***/ }),

/***/ 7187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(88739);

/***/ }),

/***/ 37739:
/***/ (function(module) {

function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
module.exports = _objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

}]);